var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$store.state.stepperNow == 'welcome' && _vm.widthNow >= 550)?_c('Welcome'):_vm._e(),(this.$store.state.stepperNow == 'welcome' && _vm.widthNow <= 550)?_c('WelcomeMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }